import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/core/styles";
import axios from "../../config/axios";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TextField, Button } from "@material-ui/core";
import { masterTableSlugs } from "assets/constants/constants";
import { useSnackbar } from "notistack";
import { isEmpty } from "lodash";

const useStyles = makeStyles({
  table: {
    minWidth: 650,
    maxWidth: 800
  }
});

export const MasterSetting = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const [masterDetails, setMasterDetails] = useState({});

  const details = {
    // [masterTableSlugs.TRIAL_PERIOD]: { title: t("masterSettings.trialPeriod"), type: t("masterSettings.days") },
    // [masterTableSlugs.SHIPPING_COST]: { title: t("masterSettings.shippingCostDiscount"), type: t("masterSettings.euro") },
    // [masterTableSlugs.NEW_USER_REFERRAL_BONUS]: { title: t("masterSettings.newUserReferralBonus"), type: t("masterSettings.euro") },
    // [masterTableSlugs.EXISTING_USER_REFERRAL_BONUS]: { title: t("masterSettings.existingUserReferralBonus"), type: t("masterSettings.euro") },
    [masterTableSlugs.EXTRA_SHIPPING_COST_AFTER_KILOMETERS]: { title: t("masterSettings.extraShippingCostAfterKm"), type: t("masterSettings.kilometer") },
    [masterTableSlugs.EXTRA_EURO_PER_KILOMETER]: { title: t("masterSettings.extraEuroPerKm"), type: t("masterSettings.euro") },
    [masterTableSlugs.EXTRA_COST_PER_FLOOR]: { title: t("masterSettings.extraCostPerFloor"), type: t("masterSettings.euro") },
    [masterTableSlugs.RECYCLING_FLAT_RATE]: { title: t("masterSettings.recyclingFlatRate"), type: t("masterSettings.euro") },
    [masterTableSlugs.FLAT_PICKUP_COST]: { title: t("masterSettings.flatPickupCost"), type: t("masterSettings.euro") }
  };

  const handleChange = (slug, value) => {
    // Armazena como string para permitir edição; conversão feita no save
    setMasterDetails({ ...masterDetails, [slug]: value });
  };

  useEffect(() => {
    axios
      .get(`/admin/master-settings`)
      .then(res => {
        setMasterDetails(res.data.data);
      })
      .catch(error => {
        enqueueSnackbar(error, { variant: "error" });
      });
  }, [enqueueSnackbar]);

  const handleClickSave = () => {
    const invalidKeys = Object.keys(details).filter(slug => {
      const n = Number(masterDetails[slug]);
      return masterDetails[slug] === "" || masterDetails[slug] === undefined || !Number.isFinite(n);
    });
    if (invalidKeys.length > 0) {
      enqueueSnackbar("Preenche todos os campos com um valor numérico válido.", { variant: "error" });
      return;
    }
    const masterDetailsPayload = {};
    Object.keys(details).forEach(slug => { masterDetailsPayload[slug] = Number(masterDetails[slug]); });
    setIsLoading(true);
    axios
      .patch("/admin/master-settings", { masterDetails: masterDetailsPayload })
      .then(res => {
        setIsLoading(false);
        enqueueSnackbar(t("masterSettings.detailsUpdated"), { variant: "success" });
      })
      .catch(error => {
        setIsLoading(false);
        enqueueSnackbar(error, { variant: "error" });
      });
  };

  if (isEmpty(masterDetails)) return <></>;

  return (
    <div className="container">
      <TableContainer component={Paper}>
        <Table className={classes.table} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>{t("masterSettings.name")}</TableCell>
              <TableCell>{t("masterSettings.typeOfValue")}</TableCell>
              <TableCell align="right">{t("masterSettings.value")}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {Object.keys(details).map(slugValue => {
              return (
                <TableRow key={slugValue}>
                  <TableCell>{details[slugValue].title}</TableCell>
                  <TableCell>{details[slugValue].type}</TableCell>
                  <TableCell align="right">
                    <TextField
                      id={`outlined-${slugValue}`}
                      label=""
                      value={masterDetails[slugValue] || ""}
                      type="number"
                      onChange={event => handleChange(slugValue, event.target.value)}
                      InputLabelProps={{
                        shrink: true
                      }}
                      InputProps={{ inputProps: { min: 0 } }}
                      variant="outlined"
                    />
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <div style={{ display: "flex", margin: "5px" }}>
        <Button style={{ width: "90px" }} className="d-flex" variant="contained" size="small" color="primary" onClick={handleClickSave}>
          {isLoading ? t("masterSettings.loading") : t("masterSettings.save")}
        </Button>
      </div>
    </div>
  );
};
